// extracted by mini-css-extract-plugin
export default {"block":"block--eb2eec","links-block":"links-block--a22292","linksBlock":"links-block--a22292"};